import {
  MicroNavigatorProvider,
  PageItem,
} from "../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import CreatePolePage from "./CreatePage/CreatePolePage";
import EditPolePage from "./EditPolePage/EditPolePage";
import PoleListPage from "./PoleListPage/PoleListPage";
import SinglePolePage from "./SinglePolePage/SinglePolePage";
import { RequireCapability } from "../../../features/rbac";

const PolePages = () => {
  return (
    <MicroNavigatorProvider>
      <PageItem path={"list"} PageRender={() => <PoleListPage />} isDefault />
      <PageItem path={"single"} PageRender={() => <SinglePolePage />} />
      <PageItem path={"create"} PageRender={() => <RequireCapability capability="planbt.edit"><CreatePolePage /></RequireCapability>} />
      <PageItem path={"edit"} PageRender={() => <RequireCapability capability="planbt.edit"><EditPolePage /></RequireCapability>} />
    </MicroNavigatorProvider>
  );
};

export default PolePages;
